import { logger } from 'Utils/Logger';
import { GIFTING_PURCHASE_MODE } from 'Utils/Constants';
import { UPDATE_PURCHASE_MODE } from '../Types';

export const updatePurchaseMode = (payload) => ({ type: UPDATE_PURCHASE_MODE, payload });

export const setPurchaseMode = (purchaseModeName) => async (dispatch, getState) => {
  const {
    appConfig: {
      defaultConfig: { purchaseModeList },
    },
  } = getState();

  const activePurchaseMode = purchaseModeList[purchaseModeName];

  if (activePurchaseMode) {
    dispatch(updatePurchaseMode(activePurchaseMode));
  } else {
    console.debug(`ERROR: no purchaseMode found of type: ${purchaseModeName}`);
  }
};

export const resetPurchaseMode = () => async (dispatch, getState) => {
  const {
    appConfig: {
      defaultConfig: { defaultPurchaseMode },
    },
  } = getState();
  dispatch(setPurchaseMode(defaultPurchaseMode));
};

export const fetchEventState =
  (isGiftingRelatedPage = false) =>
  async (dispatch, getState) => {
    const {
      appConfig: {
        defaultConfig: { defaultPurchaseMode, purchaseModeList },
      },
    } = getState();
    const purchaseMode = isGiftingRelatedPage ? GIFTING_PURCHASE_MODE : defaultPurchaseMode;
    const availablePurchaseModes = Object.keys(purchaseModeList);
    if (availablePurchaseModes.includes(purchaseMode)) {
      dispatch(setPurchaseMode(purchaseMode));
    } else {
      const error = `Incorrect purchase mode of "${purchaseMode}". Must be one of the following: ${availablePurchaseModes.join(
        ', '
      )}`;
      logger.error('fetch event state', { purchaseMode, purchaseModeList }, error);
      throw new Error(error);
    }
  };
